export const isClickOnElement = (event, element) => {
  const { target } = event
  return target === element || element.contains(target)
}

export const useFormatMoney = (code, curr, value) => {
  if (!value) return 0
  return new Intl.NumberFormat(code, {
    style: 'currency',
    useGrouping: true,
    minimumFractionDigits: 2,
    currency: curr,
    numberingSystem: 'latn',
  }).format(value)
}

import { en } from '@/assets/data/translations_fallback'
export const getTranslationsFallback = async () => {
  return en
}
